import { defineComponent as i, openBlock as a, createElementBlock as o, Fragment as m, renderSlot as n, createCommentVNode as s } from "vue";
import { _ as p } from "../../../_plugin-vue_export-helper-dad06003.js";
const u = i({
  name: "VABTest",
  props: {
    name: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      currentExperiments: []
    };
  },
  computed: {
    showVariant() {
      return this.name && Array.isArray(this.currentExperiments) ? this.currentExperiments.includes(this.name) : !1;
    }
  },
  created() {
    this.currentExperiments = this.getListOfExperiments();
  },
  methods: {
    getListOfExperiments() {
      var r;
      let e = [];
      const t = (r = document.getElementById("hey-obi-app")) == null ? void 0 : r.dataset.experiments;
      return t && (e = t.split(",")), e;
    }
  }
});
function c(e, t, r, d, l, f) {
  return a(), o(m, null, [
    e.showVariant ? s("", !0) : n(e.$slots, "control", { key: 0 }),
    e.showVariant ? n(e.$slots, "variant", { key: 1 }) : s("", !0)
  ], 64);
}
const x = /* @__PURE__ */ p(u, [["render", c]]);
export {
  x as default
};
